import React, { useCallback, useEffect, useState, useContext, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { classNames } from "primereact/utils";
import { CSSTransition } from "react-transition-group";
import { Ripple } from "primereact/ripple";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js";
import { useHistory } from "react-router-dom";
import { poolData } from "./lib/constants";
import { superAdmin, designerAdmin } from "./lib/constants";
import { RTLContext } from "./App";
import { OverlayPanel } from 'primereact/overlaypanel';

const submenuClose = {
    "Towers" : "towers-menu",
    "Asset Monitoring":  "site-details"
}

const AppSubmenu = (props) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const location = useLocation()
    const serviceType = JSON.parse(localStorage.getItem("service"))?.serviceTypeName
    
    const onMenuItemClick = (event, item, index) => {
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        if (props.root && props.onRootItemClick) {
            props.onRootItemClick({
                originalEvent: event,
                item: item,
            });
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
            event.preventDefault();
        }

        if (item.items) {
            setActiveIndex(activeIndex === index ? null : index);
        } else {
            if (props.menuMode !== "static") {
                const ink = getInk(event.currentTarget);
                if (ink) {
                    removeClass(ink, "p-ink-active");
                }
            }
        }

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item,
            });
        }
    };

    const getInk = (el) => {
        for (let i = 0; i < el.children.length; i++) {
            if (typeof el.children[i].className === "string" && el.children[i].className.indexOf("p-ink") !== -1) {
                return el.children[i];
            }
        }
        return null;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const onMenuItemMouseEnter = (index) => {
        if (props.root && props.menuActive && isHorizontalOrSlim() && !isMobile()) {
            setActiveIndex(index);
        }
    };

    const visible = (item) => {
        return typeof item.visible === "function" ? item.visible() : item.visible !== false;
    };

    const isHorizontalOrSlim = useCallback(() => {
        return props.menuMode === "horizontal" || props.menuMode === "slim";
    }, [props.menuMode]);

    const isMobile = useCallback(() => {
        return window.innerWidth < 1025;
    }, []);

    const isHorizontal = () => {
        return props.menuMode === "horizontal";
    };
    const isSlim = () => {
        return props.menuMode === "slim";
    };

    useEffect(() => {
        if (!props.menuActive && isHorizontalOrSlim() && !isMobile()) {
            setActiveIndex(null);
        }
    }, [props.menuActive, isHorizontalOrSlim, isMobile]);
    useEffect(()=>{
         function handleMenu (){
            if(location.pathname.indexOf(submenuClose[serviceType]) === -1){
                setActiveIndex(null)
            }
        }
        handleMenu()
      
    },[location.pathname])

    const getLink = (item, index) => {
        const menuitemIconClassName = classNames("layout-menuitem-icon", item.icon);
        const content = (
            <>
                {item.iconurl ? (
                    <object data={item.iconurl} width="20" height="20">
                        {" "}
                    </object>
                ) : (
                    <i className={menuitemIconClassName}></i>
                )}
                <span className="layout-menuitem-text">{item.label}</span>
                {item.badge && <Badge value={item.badge} style={item.badgeStyle} className={classNames(item.badgeClassName, "p-badge-no-gutter")} />}
                {item.items && <i className="pi pi-fw pi-angle-down layout-submenu-toggler"></i>}
                <Ripple />
            </>
        );
        const commonLinkProps = {
            // style:{fontFamily:"Inter",fontSize:"1.1rem",fontStyle:"normal",fontWeight:"500",lineHeight:"0.95rem"},
            style:{fontFamily:"Larken",fontSize:"1.1rem", fontStyle:"normal",fontWeight:700,lineHeight:"0.95rem", color: "#47422F" },
            className: classNames(item.className, "p-ripple tooltip", { "p-disabled": item.disabled, "p-link": !item.to }),
            target: item.target,
            onClick: (e) => onMenuItemClick(e, item, index),
            onMouseEnter: () => onMenuItemMouseEnter(index),
        };

        if (item.url) {
            return (
                <a data-pr-tooltip={props.root && item.label} href={item.url} rel="noopener noreferrer" {...commonLinkProps}>
                    {content}
                </a>
            );
        } else if (!item.to) {
            return (
                <a data-pr-tooltip={props.root && item.label} type="button" {...commonLinkProps}>
                    {content}
                </a>
            );
        }

        return (
            <NavLink data-pr-tooltip={props.root && item.label} to={item.to} exact activeClassName="router-link-active" {...commonLinkProps}>
                {content}
            </NavLink>
        );
    };

    const getItems = () => {
        const transitionTimeout = props.root ? 0 : { enter: 1000, exit: 450 };
        return props.items.map((item, i) => {
            if (visible(item)) {
                const active = activeIndex === i;
                let styleClass = classNames(item.badgeStyleClass, { "active-menuitem": active }, { "layout-root-menuitem": props.root });
                const link = getLink(item, i);
                let tooltip = props.root && (
                    <div>
                        <span className="layout-menuitem-text font-larken" style={{ textTransform: "uppercase", fontSize: "16px" }}>
                            {item.label}
                        </span>
                    </div>
                );

                return (
                    <li key={item.label || i} className={styleClass} role="menuitem" style={{ fontSize: "18px"}}>
                        {link}
                        {tooltip}
                        <CSSTransition classNames="layout-submenu-container" timeout={transitionTimeout} in={item.items && (props.root && !((isHorizontal() || isSlim()) && !isMobile() && (!isSlim() || (isSlim() && activeIndex !== null))) ? true : active)} unmountOnExit>
                            <AppSubmenu items={visible(item) && item.items} onMenuItemClick={props.onMenuItemClick} menuMode={props.menuMode} menuActive={props.menuActive} parentMenuItemActive={active}></AppSubmenu>
                        </CSSTransition>
                    </li>
                );
            }

            return null;
        });
    };

    if (!props.items) {
        return null;
    }

    const items = getItems();

    return (
        <>
            <ul role="menu" className={props.className} style={{backgroundColor: "#E5E1CF"}}>
                {items}
            </ul>
            {isSlim() && props.root && <Tooltip target="li:not(.active-menuitem)>.tooltip" />}
        </>
    );
};

const AppMenu = (props) => {
    let nqpermissions = JSON.parse(localStorage.getItem("permissions"));
    const image = localStorage.getItem("profileImg");
    const { isRTL } = useContext(RTLContext);
    const history = useHistory();
    const userPool = new CognitoUserPool(poolData);
    let admin = 0;
    const op = useRef(null);
    
    const isSuperAdmin = nqpermissions.includes(superAdmin);
    const isDesignerAdmin = nqpermissions.includes(designerAdmin);

    JSON.parse(localStorage.getItem("permissions")).map((item) => {
        if (item === "BuildOperateDataPipelineSetup.READ" || item === "BuildOperateDataPipelineSetup.WRITE") admin++;
    });
    useEffect(() => {
        const handleScroll = () => {
            if (op.current) {
                op.current.hide();
            }
        };
        window.addEventListener('scroll', handleScroll, true);

        return () => {
        window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);
    

    const goLogin = () => {
        op.current.hide();
        history.push("/login");
    };
    const signout = async () => {
        cognitoSignout();
        localStorage.clear();
        localStorage.clear();
        goLogin();
    };

    const cognitoSignout = () => {
        let userData = {
            Username: localStorage.getItem("email"),
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);
        cognitoUser.signOut();
    };

    const onManageUsers = () => {
        op.current.hide();
        history.push("/manage-users");
    };

    const changePassword = () => {
        op.current.hide();
        history.push("/change-user-password");
    };
    const userNameOnNavbaar = (name) => {
        let finalName = "";
        if (name) {
            if (name.length >= 18) finalName = name.slice(0, 16) + "...";
            else finalName = name;
        }
        return finalName;
    };
    return (
        <div className="h-full flex flex-column">
            <AppSubmenu items={props.model} className="layout-menu flex-1" menuActive={props.active} onRootItemClick={props.onRootMenuItemClick} onMenuItemClick={props.onMenuItemClick} root={true} menuMode={props.menuMode} parentMenuItemActive={true} />
            <div className="h-auto px-3 py-1">
                <div className="profile-box" onClick={(event) => { 
                        props.onTopbarItemClick({ originalEvent: event, item: "profile" }); 
                        op.current.toggle(event)
                    }} style={{ cursor: "pointer" }}>
                    <button className="p-0" style={{ backgroundColor: "transparent", border: "none", cursor: "pointer" }}>
                        {image ? <img src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(image)} alt="avatar" style={{ width: "30px", height: "30px", borderRadius: "50%" }} /> : <i className="pi pi-user fs-large "></i>}
                    </button>
                    <div className="flex flex-column m-0 p-0 profileDetails">
                        <p className="m-0 p-0" style={{ fontSize: "0.85rem", fontWeight: "700", fontStyle: "Inter", color: "#0F172A" }}>
                            {userNameOnNavbaar(localStorage.getItem("username"))}
                        </p>
                        <p className="m-0 p-0 " style={{ color: "#74788D", fontSize: "12px", fontWeight: "700" }}>
                            {admin === 2 && "Admin"}
                        </p>
                    </div>
                </div>
                <OverlayPanel ref={op} id="overlay_panel" style={{ width: '250px', padding: 0, margin: 0 }} appendTo={document.body} dismissable closeOnEscape>
                    <ul className="layout-topbar-action-panel" style={{ padding: 4, textDecoration: "none", listStyle: "none" }}>
                        <li className="layout-topbar-action-item flex flex-row align-items-start p-link">
                            <button className="px-2 p-link" onClick={(event) => props.onTopbarItemClick({ originalEvent: event, item: "profile" })}>
                                {image ? <img src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(image)} className="rounded-circle" alt="avatar" style={{ width: "40px", height: "40px" }} /> : null}
                            </button>
                            <div className="flex-1 flex flex-column p-2 mt-1" style={{ height: "40px" }}>
                                <p className="font-bold m-0 p-0">{localStorage.getItem("username")}</p>
                                <p className="m-0 p-0">{localStorage.getItem("email")}</p>
                            </div>
                        </li>
                        {isSuperAdmin || isDesignerAdmin ? (
                            <li className="layout-topbar-action-item" onClick={onManageUsers}>
                                <button className="flex flex-row align-items-center p-link">
                                    <i className="fa-regular fa-user mr-2"></i>
                                    <span>Manage Users</span>
                                </button>
                            </li>
                        ) : null}

                        <li className="layout-topbar-action-item" onClick={changePassword}>
                            <button className="flex flex-row align-items-center p-link">
                                <img style={{ marginRight: "0.5rem" }} src={process.env.PUBLIC_URL + "/images/change-password-icon.svg"} />
                                <span>Change Password</span>
                            </button>
                        </li>
                        <li className="layout-topbar-action-item" onClick={signout}>
                            <button className="flex flex-row align-items-center p-link">
                                <i className={classNames("pi pi-power-off", { "mr-2": !isRTL, "ml-2": isRTL })}></i>
                                <span>Logout</span>
                            </button>
                        </li>
                    </ul>
                </OverlayPanel>
            </div>
        </div>
    );
};

export default AppMenu;
